import { TKeyCountryIndicatorStoreState } from './types';

export function getIndicators(state: TKeyCountryIndicatorStoreState) {
  return state.indicators;
}

export function getCountriesList(state: TKeyCountryIndicatorStoreState) {
  return state.countriesList;
}
